import { useEffect, useRef } from "react";
import { io, Socket } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL;

interface OrderUpdate {
    orderId: number;
    status: string;
    customerId?: number;
    orderNumber?: string;
    autoPrintInvoice?: boolean;
    autoAccept?: boolean;
}

export const useOrderSocket = (
    storeId: number | undefined,
    onOrderUpdated: (data: OrderUpdate) => void
) => {
    const socketRef = useRef<Socket | null>(null);
    const callbackRef = useRef(onOrderUpdated);

    useEffect(() => {
        callbackRef.current = onOrderUpdated;
    }, [onOrderUpdated]);

    useEffect(() => {
        if (!storeId) {
            return;
        }

        const socket = io(SOCKET_URL, {
            transports: ["websocket"],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
            reconnectionAttempts: 5
        });
        socketRef.current = socket;

        socket.on("connect", () => {
            socket.emit("joinRoom", `store-${storeId}`);
        });

        socket.on("orderUpdated", (data: OrderUpdate) => {
            callbackRef.current(data);
        });

        socket.on("connect_error", () => { });

        socket.on("error", () => { });

        socket.on("reconnect_attempt", () => { });

        socket.on("disconnect", () => {
        });

        return () => {
            socket.disconnect();
            socketRef.current = null;
        };
    }, [storeId]);
};